import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAnalyzerCriterionEntity } from './conversation-analyzer-criterion.entity';

export interface AnalyzerConfig {
	maxScore?: number;
	passingScore?: number;
}

@Entity('_conversation_analyzer')
@Index('idx_owner_agent', ['ownerAgentId'])
export class ConversationAnalyzerEntity extends BaseEntity {
	@Column({ name: 'name', type: 'varchar', length: 100, nullable: false })
	public name!: string;

	@Column({ name: 'description', type: 'text', nullable: true })
	public description?: string;

	@Column({ name: 'is_active', type: 'boolean', width: 1, default: 1 })
	public isActive!: boolean;

	// PD-16872 — legacy: no longer read, and only written on create with the
	// platform's choice. Every analyzer runs on PLATFORM_ANALYZER_LLM
	// (platform-engines.ts); each analysis result records the model used.
	@Column({
		name: 'llm_provider',
		type: 'varchar',
		length: 50,
		default: "'claude'",
	})
	public llmProvider!: string;

	@Column({ name: 'llm_model', type: 'varchar', length: 100, nullable: true })
	public llmModel?: string;

	@Column({ name: 'config', type: 'json', nullable: true })
	public config?: AnalyzerConfig;

	/**
	 * The agent that owns this analyzer, or null for a library analyzer.
	 *
	 * An owned analyzer is the private analyzer behind one agent's "simple"
	 * Success Criteria grading: the server creates and maintains it from the
	 * agent's success prompt (AgentGradingService). It is hidden from the
	 * analyzer library and cannot be linked to any other agent, so editing
	 * one agent's success prompt can never change how another agent is
	 * graded. A plain column (no relation) because the agent entity already
	 * imports this one.
	 */
	@Column({
		name: 'fk__conversation_agent__id_owner',
		type: 'int',
		unsigned: true,
		nullable: true,
		comment: 'Agent that privately owns this analyzer; null = library analyzer',
	})
	public ownerAgentId?: number | null;

	@OneToMany(() => ConversationAnalyzerCriterionEntity, (c) => c.analyzer)
	public criteria?: Array<ConversationAnalyzerCriterionEntity>;
}
